// extracted by mini-css-extract-plugin
module.exports = {"app-wrapper":"App_app-wrapper__Gmsf_"};